import React from 'react'

import SectionContainer from 'components/atoms/SectionContainer'
import Container from 'components/atoms/Container'
import Row from 'components/atoms/Row'
import Col from 'components/atoms/Col'
import Typography from 'components/atoms/Typography'

import Relazsizes from 'relazsizes'

import config from 'config'

const { assets_url: assetsUrl } = config

const AptitudeExplanation = () => (
  <div id="aptitude-explanation" className="aptitude-explanation">
    <SectionContainer
      className="aptitude-explanation__section"
      paddingBottom={120}
      backgroundColor="#bcefe2"
    >
      <Container className="aptitude-explanation__container">
        <Row>
          <Col md="6">
            <Relazsizes
              dataSrc={`${assetsUrl}/assets/img/aptitude/riasec-x2.png`}
              className="aptitude-explanation__img"
              alt="Bagaimana Cara Kerja Tes Minat Bakat?"
            />
          </Col>
          <Col md={{ size: 5, offset: 7 }}>
            <div className="aptitude-explanation__content">
              <Typography component="h2" variant="title" className="text-variant-title-sm aptitude-explanation__title">
                Bagaimana Cara Kerja Tes Minat Bakat?
              </Typography>
              <Typography component="p" variant="subbody" className="aptitude-explanation__desc">
                <span className="text-bold">Tes Minat Bakat Quipper Campus</span> bekerja sama dengan para pakar psikologi andal di bidangnya agar kamu mendapatkan hasil Tes Minat Bakat yang akurat. Formula disusun berdasarkan teori kepribadian RIASEC yang sudah terbukti mampu menggali potensi seseorang berdasarkan kepribadiannya.
              </Typography>
            </div>
          </Col>
        </Row>
      </Container>
    </SectionContainer>
    <style jsx global>
      {`
        .aptitude-explanation {
          overflow: hidden;
          &__section {
            position: relative;
          }
          &__container {
            position: relative;
          }
          &__title,
          &__desc,
          &__source-note {
            color: #0c2846 !important;
          }
          &__title {
            margin-bottom: 0 !important;
          }
          &__desc {
            line-height: 2;
            margin: 16px 0 !important;
          }
          &__img {
            width: 100%;
          }
          &__content {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
          }
          .text-bold {
            font-weight: bold;
          }
        }
      `}
    </style>
  </div>
)

export default AptitudeExplanation
